<template>
  <footer id="footer"
    :class="curBrand == 'kia' ? 'footer_kia' : curBrand == 'audi' ? 'footer_audi' : curBrand == 'volkswagen' ? 'footer_vw' : curBrand == 'bentley' ? 'footer_bentley' : 'footer'">
    <div class="container">
      <div class="chatbox-float">
        <a class="whatsapp-icon" href="https://bit.ly/klmuweb" target="_blank"></a>
      </div>
      <div class="footer-navigation">
        <ul class="tnc-wrapper">
          <li v-for="(item, index) in (navChildList.length > 0 ? navList.slice(0, 1) : navList)" :key="index">
            <router-link :to="item.url">{{ item.title }}</router-link>
          </li>
          <li v-for="(item, index) in navChildList" :key="index + 10">
            <router-link :to="item.url">{{ item.title }}</router-link>
          </li>
          <!-- <li>
            <router-link to="/termsofuse" @click.native="on('/termsofuse')">{{$t('footer.terms')}}</router-link>
          </li> -->
          <li>
            <router-link to="/privacypolicy" @click.native="on('/privacypolicy')">{{ $t('footer.privacy')
            }}</router-link>
          </li>
          <!-- <li>
            <router-link to="/cookie">Cookie Policy</router-link>
          </li> -->
        </ul>
        <ol class="tnc-wrapper-right">
          <li><a class="iconfont" href="https://www.facebook.com/KLMpreowned" target="_blank"
              title="KLM on Facebook">&#xe601;</a></li>
          <!-- <li><a class="iconfont" href="https://www.youtube.com/channel/UCUQhy03y9G4WoAVriDQOyiw" target="_blank" title="YouTube">&#xe7af;</a></li> -->
          <!-- <li><a class="iconfont" href="https://www.instagram.com/audihk/" target="_blank" title="Instagram">&#xe600;</a></li> -->
        </ol>
      </div>
      <div class="copyright">
        <p class="copy" v-html="$t('footer.copy')"></p>
      </div>
    </div>
  </footer>
</template>

<script>
import PubSub from 'pubsub-js'
import { mapState } from 'vuex';

export default {
  name: "Footer",
  props: ['text'],
  inject: ['reload'],
  data() {
    return {
      collapsed: false,
      screenWidth: document.body.clientWidth,
      isFixed: false,
      navList: [],
      navChildList: []
    }
  },
  mounted() {
    PubSub.subscribe('navs', (msg, data) => {
      // console.log('msg', msg)
      // console.log('data', data)
      if (data.length != 0) {
        this.navList = data
      }
    })
    PubSub.subscribe('navsChild', (msg, data) => {
      // console.log('msg', msg)
      // console.log('data', data)
      if (data.length != 0) {
        this.navChildList = data
      }
    })
  },
  methods: {
    on(url) {
      // 发布消息
      PubSub.publish('on', { url: url, on: 'on' })
    }
  },
  computed: {
    ...mapState(['curBrand'])
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
// 按钮 whatsapp
.chatbox-float {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1110;

  .whatsapp-icon {
    // position: absolute;
    // bottom: -70px;
    display: block;
    width: 64px;
    height: 70px;
    cursor: pointer;
    background: url('../images/i-whatsapp.png') no-repeat center center;
    background-size: contain;
  }
}

/* footer */
#footer {
  color: #fff;
  height: auto;
  width: 100%;
}
.footer {
  background-color: #4c4c4c;
  .copyright {
    border-top: 1px solid #666;
    color: #999;
  }
}
.footer_kia {
  background-color: var(--parent-color);
  .copyright {
    border-top: 1px solid #fff;
    color: #fff;
  }
}
.footer_audi {
  background-color: var(--parent-color);
  .copyright {
    border-top: 2px solid rgba(252, 252, 253, 0.2);
    color: #fff;
  }
}
.footer_vw {
  background-color: #fff;
  border-top: 2px solid rgb(0, 30, 80);
  .copyright {
    border-top: 2px solid rgb(223, 228, 232);
    color: rgb(0, 30, 80); //#001e50
  }
  .tnc-wrapper li a {
    color: rgb(0, 30, 80) !important;
  }
}

.footer_bentley {
  background-color: #fff;
  border-top: 2px solid #e0e0e0;
  .copyright {
    border-top: 2px solid #e0e0e0;
    color: #757575; //#001e50
  }
  .tnc-wrapper li a {
    color: #394D45 !important;
    font-weight: 500;
    &:hover {
      color: #003220 !important;
    }
  }
}


#footer .tnc-wrapper, #footer .tnc-wrapper-right {
  float: left;
  height: 50px;
  line-height: 50px;
  list-style: none;
  padding: 0;
  margin: 0;
}

#footer .tnc-wrapper li {
  float: left;
}

#footer .tnc-wrapper li a {
  // border-right: 1px solid #fff;
  // font-family: 'AttenNewRegular', 'Source Han Sans CN';
  font-size: 14px;
  margin-right: 20px;
  color: #fff;
  text-decoration: none;
}

#footer .tnc-wrapper li:last-child a {
  border-right: 0;
}

#footer .tnc-wrapper-right {
  float: right;

  li {
    float: left;

    a {
      display: block;
      font-size: 30px;
      padding: 0 14px;
      color: #fff;
      text-decoration: none;
    }
  }
}

#footer .footer-navigation {
  overflow: hidden;
  padding-top: 26px;
  padding-bottom: 20px;
}

#footer .copyright {
  padding-top: 18px;
  padding-bottom: 50px;
}

#footer .copy {
  font-size: 12px;
}

@media (max-width: 767px) {
  /* footer */
  #footer {
    height: auto;
  }

  #footer #facebook-btn, #footer #youtube-btn {
    margin-bottom: 10px;
  }

  #footer .tnc-wrapper {
    width: 100%;
    height: auto;
    line-height: 32px;
    overflow: hidden;
  }

  #footer .tnc-wrapper {
    margin-bottom: 10px;
  }

  #footer .copyright {
    padding-bottom: 20px;
  }

  #footer .tnc-wrapper {
    width: 100%;
    float: none;
  }

  #footer .tnc-wrapper-right {
    width: 100%;
    float: none;

    li {
      float: left;

      a {
        display: block;
        font-size: 28px;
        padding: 0 14px;
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue